export default __webpack_public_path__ + "static/media/basics-business.29d010e5.jpg";